import StatisticsCharts from './StatisticsCharts';

export default StatisticsCharts;
